import React, { useState, useEffect } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { fetchAPI } from "../utils/api";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";

import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  ShimmerThumbnail,
  ShimmerTitle,
  ShimmerText,
  ShimmerButton,
} from "react-shimmer-effects";

// Sub-component for individual related equipment card to manage its own selected rental duration
function RelatedEquipmentCard({ item, onProductClick }) {
  const rentalOptions = item.attribute || [];
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(0);
  const currentAttr = rentalOptions[selectedAttrIndex] || null;
  const displayPrice = currentAttr
    ? currentAttr.price
    : item.me_security_amount || "0";

  const handleOptionClick = (e, idx) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAttrIndex(idx);
  };

  return (
    <Link
      to={`/product/${item.me_slug || item.me_id}`}
      state={{
        product: item,
        selectedAttrIndex,
        selectedAttrId: currentAttr?.attribute_value_id,
        selectedAttribute: currentAttr,
      }}
      onClick={() => onProductClick(item)}
    >
      <div className="equip-box" style={{ margin: "10px 0" }}>
        {item.me_category === "1" && <span className="badge">Bestseller</span>}

        <div className="eqip-img">
          <img
            src={item.me_image || "/placeholder.png"}
            alt={item.me_product_name}
            className="img-fluid"
          />
        </div>

        <div className="equipment_content">
          <h3 style={{ fontSize: "16px", minHeight: "44px" }}>
            {item.me_product_name}
          </h3>

          <div className="star_review">
            <div className="stars">
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
            </div>
            <p className="starpera">
              <span> 4.8 </span>
            </p>
          </div>

          {rentalOptions.length > 0 && (
            <div className="days-booking">
              <p style={{ margin: 0 }}>Rent : </p>
              {rentalOptions.map((opt, idx) => (
                <span
                  key={opt.attribute_value_id}
                  onClick={(e) => handleOptionClick(e, idx)}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      selectedAttrIndex === idx ? "#13baac" : "#ffffff",
                    borderColor:
                      selectedAttrIndex === idx ? "#13baac" : "#d7d7d7",
                    color:
                      selectedAttrIndex === idx
                        ? "#ffffff"
                        : "var(--dark-grey)",
                    userSelect: "none",
                  }}
                >
                  {opt.attribute_value}
                </span>
              ))}
            </div>
          )}

          <div className="price-divider"></div>

          <div className="price-row">
            <div className="medicine-price">
              <span className="sale-price">
                ₹{displayPrice}
                {currentAttr && currentAttr.attribute_value ? (
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#666",
                      marginLeft: "3px",
                      textTransform: "lowercase",
                    }}
                  >
                    / {currentAttr.attribute_value.toLowerCase()}
                  </span>
                ) : (
                  "/-"
                )}
              </span>
            </div>
            <button
              className="medicine-add-btn"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                backgroundColor: "#13baac",
                backgroundImage: "linear-gradient(180deg, #13baac, #0c8485)",
                color: "#ffffff",
                border: "none",
                padding: "6px 14px",
                borderRadius: "5px",
                fontWeight: "500",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}

function MedicineDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location.state?.product || null);
  const [loading, setLoading] = useState(!location.state?.product);
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(0);
  const [counter, setCounter] = useState(1);
  const [mainImg, setMainImg] = useState("");
  const [images, setImages] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);

  // Fetch product detail if not passed in route state
  useEffect(() => {
    const loadProductDetail = async () => {
      let prodId = id;
      if (!prodId) {
        const params = new URLSearchParams(location.search);
        prodId = params.get("id");
      }

      // Default fallback product ID (e.g. 3 for Manual Fowler Bed)
      if (!prodId) {
        prodId = 3;
      }

      try {
        setLoading(true);
        const data = await fetchAPI("EquipmentsController/products_detail", {
          method: "POST",
          body: JSON.stringify({ product_id: prodId }),
        });
        if (data.status === 200 && data.result) {
          setProduct(data.result);
        } else {
          console.error("Product details not found or failed:", data.msg);
        }
      } catch (err) {
        console.error("Error loading product detail from API:", err);
      } finally {
        setLoading(false);
      }
    };

    loadProductDetail();
  }, [id, location.search]);

  // Set images, mainImg, and attribute selection when product changes
  useEffect(() => {
    if (product) {
      const imgList = product.me_image ? [product.me_image] : [];
      setImages(imgList);
      setMainImg(imgList[0] || "/placeholder.png");

      let targetIdx = 0;
      if (
        location.state?.selectedAttrIndex !== undefined &&
        location.state?.selectedAttrIndex !== null
      ) {
        targetIdx = location.state.selectedAttrIndex;
      } else if (
        (location.state?.selectedAttrId || location.state?.selectedAttribute) &&
        product.attribute
      ) {
        const reqId =
          location.state?.selectedAttrId ||
          location.state?.selectedAttribute?.attribute_value_id;
        const reqVal = location.state?.selectedAttribute?.attribute_value;
        const foundIdx = product.attribute.findIndex(
          (a) =>
            String(a.attribute_value_id) === String(reqId) ||
            a.attribute_value === reqVal,
        );
        if (foundIdx !== -1) targetIdx = foundIdx;
      }
      setSelectedAttrIndex(targetIdx);
    }
  }, [product, location.state]);

  // Redirect /product/ID to /product/SLUG in address bar
  useEffect(() => {
    if (product && product.me_slug && id !== product.me_slug) {
      window.history.replaceState(null, "", `/product/${product.me_slug}`);
    }
  }, [product, id]);

  // Fetch related products (same category)
  useEffect(() => {
    const fetchRelated = async () => {
      if (!product || !product.me_category) return;
      try {
        const response = await fetchAPI("EquipmentsController/products", {
          method: "POST",
          body: JSON.stringify({ category_id: product.me_category }),
        });
        if (response.status === 200 && response.result) {
          // Filter out the current product
          const filtered = response.result.filter(
            (item) => String(item.me_id) !== String(product.me_id),
          );
          setRelatedProducts(filtered);
        }
      } catch (err) {
        console.error("Error fetching related products:", err);
      }
    };
    fetchRelated();
  }, [product]);

  const inc = () => {
    setCounter(counter + 1);
  };

  const dec = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

  const saveToLocalCart = (productObj, selectedAttr, qty) => {
    try {
      const saved = localStorage.getItem("selectedProductCart");
      let cartList = [];
      if (saved) {
        try {
          cartList = JSON.parse(saved);
          if (!Array.isArray(cartList)) cartList = [];
        } catch (e) {
          cartList = [];
        }
      }

      // Check if item already exists in local cart
      const existingItemIndex = cartList.findIndex(
        (item) =>
          String(item.product_id) === String(productObj.me_id) &&
          String(item.attribute_value_id || item.id) ===
            String(selectedAttr.attribute_value_id),
      );

      const addedQty = typeof counter === "number" ? counter : 1;

      if (existingItemIndex === -1) {
        const cartItem = {
          id: selectedAttr.attribute_value_id,
          attribute_value_id: selectedAttr.attribute_value_id,
          product_id: productObj.me_id,
          name: productObj.me_product_name,
          duration: selectedAttr.attribute_value,
          price: selectedAttr.price,
          security_amount: productObj.me_security_amount || "0",
          image: productObj.me_image || "/placeholder.png",
          type: "equipment",
          qty: addedQty,
        };
        cartList.push(cartItem);
      } else {
        cartList[existingItemIndex].qty =
          (cartList[existingItemIndex].qty || 1) + addedQty;
      }

      localStorage.setItem("selectedProductCart", JSON.stringify(cartList));
      localStorage.setItem("activeCartType", "product");
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error("Error saving to local cart:", err);
    }
  };

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3000);
  };

  const handleAddToCart = async () => {
    console.log(
      "handleAddToCart triggered. product:",
      product,
      "currentAttr:",
      currentAttr,
      "counter:",
      counter,
    );
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      showToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    let user;
    try {
      user = JSON.parse(userStr);
    } catch (err) {
      console.error("Error parsing user from localStorage:", err);
      showToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    if (!user || !user.user_id) {
      showToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }

    if (!currentAttr) {
      showToast("Please select a pricing plan (Rent days) first.", "warning");
      return;
    }

    try {
      const response = await fetchAPI("EquipmentsController/add_to_cart", {
        method: "POST",
        body: JSON.stringify({
          user_id: user.user_id,
          product_id: product.me_id,
          attribute_value_id: currentAttr.attribute_value_id,
          qty: counter,
        }),
      });

      if (response && response.status === 200) {
        saveToLocalCart(product, currentAttr, counter);
        showToast("Cart added successfully!", "success");
      } else {
        showToast(response.msg || "Failed to add product to cart.", "error");
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
      showToast("Something went wrong. Please try again.", "error");
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        {toast.show && (
          <div
            className={`custom-toast-notification custom-toast-${toast.type}`}
          >
            <CheckCircleIcon />
            <span>{toast.message}</span>
          </div>
        )}
        <div className="medicine-detail-section py-5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <ShimmerThumbnail height={350} rounded className="mb-3" />
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <ShimmerTitle line={1} variant="primary" className="mb-3" />
                <ShimmerTitle line={1} variant="secondary" className="mb-4" />
                <ShimmerText line={4} gap={15} className="mb-4" />
                <div className="d-flex gap-3 mt-4">
                  <ShimmerButton size="lg" />
                  <ShimmerButton size="lg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (!product) {
    return (
      <>
        <Header />
        {toast.show && (
          <div
            className={`custom-toast-notification custom-toast-${toast.type}`}
          >
            <CheckCircleIcon />
            <span>{toast.message}</span>
          </div>
        )}
        <div className="container-fluid text-center py-5">
          <h3 className="text-danger">Equipment product not found.</h3>
          <Link
            to="/product-on-rent"
            className="btn btn-primary mt-3"
            style={{ backgroundColor: "#13baac", borderColor: "#13baac" }}
          >
            Go to Equipments Page
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const rentalOptions = product.attribute || [];
  const currentAttr = rentalOptions[selectedAttrIndex] || null;
  const displayPrice = currentAttr ? parseFloat(currentAttr.price) : 0;

  return (
    <>
      <Header />
      {toast.show && (
        <div className={`custom-toast-notification custom-toast-${toast.type}`}>
          <CheckCircleIcon />
          <span>{toast.message}</span>
        </div>
      )}

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/product-on-rent">Equipments on Rent</Link>
            <span>&gt;</span>
            <span className="name_p">{product.me_product_name}</span>
          </div>
        </div>
      </div>

      <div className="medicine-detail-section">
        <div className="container-fluid">
          <div className="inner-detail">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img-section-detail">
                  <div className="gallery">
                    {/* left side */}
                    <div className="thumbnails">
                      {images.map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt=""
                          onClick={() => setMainImg(img)}
                          className={`thumb ${mainImg === img ? "active" : ""}`}
                        />
                      ))}
                    </div>

                    {/* main image */}
                    <div className="main-image">
                      <InnerImageZoom src={mainImg} zoomSrc={mainImg} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7 col-md-7 col-12">
                <div className="text-section-detail">
                  <h1 className="detail-heading">{product.me_product_name}</h1>

                  <div className="star_review">
                    <div className="stars">
                      <StarPurple500OutlinedIcon />
                      <StarPurple500OutlinedIcon />
                      <StarPurple500OutlinedIcon />
                      <StarPurple500OutlinedIcon />
                      <StarPurple500OutlinedIcon />
                    </div>
                    <p className="starpera">
                      <span> 4.8 </span>
                    </p>

                    <span class="stock">Available for rent</span>
                  </div>
                </div>

                <div className="price-outerrr">
                  <div className="stock-price">
                    <div
                      className="price-section"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span className="new-price">
                        ₹ {displayPrice}
                        {currentAttr && currentAttr.attribute_value && (
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "500",
                              color: "#666",
                              marginLeft: "6px",
                              textTransform: "lowercase",
                            }}
                          >
                            / {currentAttr.attribute_value.toLowerCase()}
                          </span>
                        )}
                      </span>
                    </div>
                  </div>

                  {rentalOptions.length > 0 && (
                    <div className="rental-duration">
                      <label className="rd-label">Rental Duration</label>
                      <div className="rd-grid">
                        {rentalOptions.map((opt, idx) => {
                          const toDays = (o) =>
                            /day/i.test(o.attribute_value)
                              ? parseInt(o.attribute_value, 10) || 0
                              : 0;
                          const days = toDays(opt);
                          const price = parseFloat(opt.price) || 0;
                          const perDay = days ? Math.round(price / days) : 0;
                          const baseDays = toDays(rentalOptions[0]);
                          const basePerDay = baseDays
                            ? parseFloat(rentalOptions[0].price) / baseDays
                            : 0;
                          const save =
                            days && basePerDay
                              ? Math.round(
                                  (1 - price / days / basePerDay) * 100,
                                )
                              : 0;
                          const active = selectedAttrIndex === idx;

                          return (
                            <button
                              type="button"
                              key={opt.attribute_value_id}
                              className={`rd-card ${active ? "active" : ""}`}
                              onClick={() => setSelectedAttrIndex(idx)}
                              aria-pressed={active}
                            >
                              {idx > 0 && save > 0 && (
                                <em className="rd-save">Save {save}%</em>
                              )}
                              <div className="days-outer">
                                <strong>₹{opt.price}</strong>{" "}
                                <b>/ {opt.attribute_value}</b>
                              </div>

                              {perDay > 0 && <span>₹{perDay} / day</span>}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  <div className="cart-quantity-what">
                    <label class="rd-label">Quantity</label>
                    <div className="counter_add_cart_section">
                      <div className="counter child detail-counter">
                        <button onClick={dec}>-</button>
                        <p className="number">{counter}</p>
                        <button onClick={inc}>+</button>
                      </div>

                      <div
                        className="add_cart_btn child"
                        style={{ width: "calc(49% - 10px)" }}
                      >
                        <button
                          className="add-cart-btn"
                          onClick={handleAddToCart}
                          style={{ width: "100%" }}
                        >
                          <ShoppingCartOutlinedIcon />
                          Add To Cart
                        </button>
                      </div>

                      <button class="wab">
                        <a
                          href="https://wa.me/919521111603"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <WhatsAppIcon />
                          Ask on WhatsApp
                        </a>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="shipping_feature">
                  <div className="eachange_outer">
                    <GppGoodOutlinedIcon />
                    <p>100% genuine products</p>
                  </div>

                  <div className="eachange_outer">
                    <CurrencyRupeeOutlinedIcon />
                    <p>Safe & secure payments</p>
                  </div>

                  <div className="eachange_outer">
                    <LocalShippingOutlinedIcon />
                    <p>Easy cancellation & return</p>
                  </div>
                </div>

                <div className="detail_accord">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Product Description</Accordion.Header>
                      <Accordion.Body>
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              product.me_description ||
                              "High quality medical equipment sanitized and verified for patient use.",
                          }}
                        />

                        {rentalOptions.length > 0 && (
                          <div
                            className="more-about-product"
                            style={{ marginTop: "25px", marginBottom: "10px" }}
                          >
                            <h4
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                color: "#444",
                                marginBottom: "15px",
                                letterSpacing: "0.5px",
                              }}
                            >
                              More About the Product
                            </h4>
                            <div
                              style={{
                                border: "1px solid #e0f2f1",
                                borderRadius: "12px",
                                padding: "5px 20px",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              {rentalOptions.map((opt, idx) => (
                                <div
                                  key={opt.attribute_value_id}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "14px 0",
                                    borderBottom:
                                      idx < rentalOptions.length - 1
                                        ? "1px solid #f0f7f7"
                                        : "none",
                                  }}
                                >
                                  <span
                                    style={{ fontSize: "15px", color: "#444" }}
                                  >
                                    <strong style={{ fontWeight: "700" }}>
                                      Rent :
                                    </strong>{" "}
                                    {opt.attribute_value}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: "16px",
                                      color: "#13baac",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ₹{opt.price}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        Refund & Return Policy
                      </Accordion.Header>
                      <Accordion.Body>
                        {product.me_refund ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: product.me_refund,
                            }}
                          />
                        ) : (
                          "We offer easy cancellation and standard returns for our rental equipment if any technical or functional defects are reported. Refer to our main terms and conditions for details."
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        Additional Information
                      </Accordion.Header>
                      <Accordion.Body>
                        {product.me_additional_info ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: product.me_additional_info,
                            }}
                          />
                        ) : (
                          "All equipments are thoroughly sanitized and tested by our experts before delivery. Support is available for installation and initial operational guidance."
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>

          {relatedProducts.length > 0 && (
            <div className="medicine-slider">
              <h3 className="title">Related Products</h3>
              <div className="slider-wrapper">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={4}
                  loop={relatedProducts.length >= 4}
                  autoplay={{ delay: 5500, disableOnInteraction: false }}
                  navigation
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 5,
                    },
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 5,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 15,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 15,
                    },
                  }}
                >
                  {relatedProducts.map((item) => (
                    <SwiperSlide key={item.me_id}>
                      <RelatedEquipmentCard
                        item={item}
                        onProductClick={setProduct}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedicineDetail;
